import { render } from "./PlotRentAdjustmentHistory.vue?vue&type=template&id=b88d6916&scoped=true"
import script from "./PlotRentAdjustmentHistory.vue?vue&type=script&lang=js"
export * from "./PlotRentAdjustmentHistory.vue?vue&type=script&lang=js"

import "./PlotRentAdjustmentHistory.vue?vue&type=style&index=0&id=b88d6916&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b88d6916"]])

export default __exports__